function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.513 38.994a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm-7.5-.151v.151H11.5a4.5 4.5 0 0 1-4.5-4.5V10.5A4.5 4.5 0 0 1 11.5 6h17.981a4.5 4.5 0 0 1 4.5 4.5v11.49a10.501 10.501 0 0 1 6.032 9.504c0 5.8-4.7 10.5-10.5 10.5a10.468 10.468 0 0 1-7.5-3.151zm-1.99-2.849a10.46 10.46 0 0 1-1.01-4.5c0-5.799 4.701-10.5 10.5-10.5.498 0 .989.035 1.468.102V10.5a1.5 1.5 0 0 0-1.5-1.5H11.5a1.5 1.5 0 0 0-1.5 1.5v23.994a1.5 1.5 0 0 0 1.5 1.5h8.523zm10.45-6.981a1.5 1.5 0 1 1 2.269 1.963l-3.45 3.986a.5.5 0 0 1-.737.02l-2.37-2.453a1.5 1.5 0 1 1 2.157-2.085l.47.488 1.661-1.92zm-15.96-14.019a1.5 1.5 0 0 1 0-3h12a1.5 1.5 0 0 1 0 3h-12zm0 6a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 0 1 0 3h-6z"
});

var Svg002Completed = function Svg002Completed(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default Svg002Completed;


//////////////////
// WEBPACK FOOTER
// ./src/icons/order-status/002-completed.svg
// module id = 220
// module chunks = 0 1